/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@compiled/react';

import { css, cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import {
	CopyLinkButton,
	EmbedPreview,
	IconTile,
	type LinkEmbedVariantProps,
	LoadingSkeleton,
	OpenLinkButton,
	TitleMeta,
} from './link-embed-shared';

const containerStyles = css({
	width: '100%',
	boxSizing: 'border-box',
	backgroundColor: token('elevation.surface.sunken'),
	borderRadius: token('radius.large'),
	overflow: 'hidden',
	paddingTop: token('space.200'),
	paddingRight: token('space.150'),
	paddingBottom: token('space.150'),
	paddingLeft: token('space.150'),
});

const headerStyles = css({
	display: 'flex',
	alignItems: 'center',
	gap: token('space.150'),
	paddingLeft: token('space.100'),
	paddingRight: token('space.100'),
});

const embedContainerStyles = cssMap({
	root: {
		width: '100%',
		marginTop: token('space.050'),
	},
});

const actionsRowStyles = css({
	display: 'flex',
	justifyContent: 'flex-end',
	gap: token('space.100'),
	paddingTop: token('space.050'),
	paddingRight: token('space.100'),
});

export const LinkEmbedCompact = ({
	url,
	title,
	provider,
	generatorName,
	iconUrl,
	previewHref,
	isLoading,
	isError,
	modifiedBy,
	updatedDate,
	secondsAgo,
	isOlderThanWeek,
	onLinkClick,
}: LinkEmbedVariantProps): JSX.Element => (
	<div css={containerStyles}>
		{isLoading ? (
			<LoadingSkeleton />
		) : (
			<div css={headerStyles}>
				<IconTile iconUrl={iconUrl} isError={isError} generatorName={generatorName} />
				<TitleMeta
					title={title}
					provider={provider}
					updatedDate={updatedDate}
					secondsAgo={secondsAgo}
					isOlderThanWeek={isOlderThanWeek}
					modifiedBy={modifiedBy}
				/>
			</div>
		)}
		{!isLoading && !isError && previewHref && (
			<Box xcss={embedContainerStyles.root}>
				<EmbedPreview url={url} previewHref={previewHref} inheritDimensions />
			</Box>
		)}
		{!isLoading && (
			<div css={actionsRowStyles}>
				<OpenLinkButton url={url} onLinkClick={onLinkClick} />
				<CopyLinkButton url={url} onLinkClick={onLinkClick} />
			</div>
		)}
	</div>
);
